import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Divider} from 'views/components';
import {RefreshWidget} from 'views/module';

import CaregiverName from './caregiver_name/CaregiverName';
import CaregiverStatus from './caregiver_status/CaregiverStatus';

const CaregiverTitle = (props) => {
  const caregiverData = props.caregiverData;
  const caregiverBackend = props.caregiverBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;

  return (
    <>
      <Stack
        direction='row'
        justifyContent={'space-between'}
        alignItems="center"
        sx={{
          p: 1,
          px: {md: 2, xs: 1},
        }}
      >
        <Box>
          <Stack
            direction='row'
            spacing={1}
          >
            <CaregiverStatus
              caregiverData={caregiverData}
              caregiverBackend={caregiverBackend}
            />
            <CaregiverName
              caregiverData={caregiverData}
              caregiverBackend={caregiverBackend}
            />
          </Stack>
        </Box>
        <Box sx={{minWidth: '37%'}}>
          <RefreshWidget numRefresh={refresh} setNumRefresh={setRefresh} justifyContent='end'/>
        </Box>
      </Stack>
      <Divider/>
    </>
  );
};
CaregiverTitle.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(CaregiverTitle);
